import { createContext, type PropsWithChildren, useContext } from "react";

import { useControlAccess, type ControlAccessState } from "./useControlAccess";

const ControlAccessContext = createContext<ControlAccessState | null>(null);

export function ControlAccessProvider({ children }: PropsWithChildren) {
  const access = useControlAccess();
  return <ControlAccessContext.Provider value={access}>{children}</ControlAccessContext.Provider>;
}

export function useControlAccessContext() {
  const value = useContext(ControlAccessContext);
  if (!value) throw new Error("useControlAccessContext doit être utilisé dans ControlAccessProvider.");
  return value;
}
